export const WorkData = [
    {
      company: "Munchin",
      designation: "React Js Developer",
      dateJoining: "Fab 2021",
      dateEnd: "May 2021",
      companyLogo:
        "https://munch-in.in/static/media/Logo.00a07c14.png",
      work: " I Worked as a React Developer at Munchin. Built landing pages for Munchin-in. Design and develop various features for the web app.",
    },
   
  ];